import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { OrderStatus } from "@/redux/services/order/order.type";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 dark:focus:ring-slate-300",
  {
    variants: {
      variant: {
        default: "bg-slate-900 text-slate-50",
        secondary: "bg-slate-200 text-slate-900",
        pending: "bg-cyan-700 text-white",
        success: "bg-green-500 text-white",
        failed: "bg-red-500 text-white",
        accepted: "bg-blue-500 text-white",
        rejected: "bg-red-500 text-white",
        preparing: "bg-orange-500 text-white",
        ready: "bg-purple-500 text-white",
        served: "bg-green-500 text-white",
        picked_up: "bg-teal-500 text-white",
        delivered: "bg-green-500 text-white",
        canceled: "bg-gray-500 text-white",
        draft: "bg-yellow-500 text-white",
        outline:
          "bg-transparent text-slate-900 ring-2 ring-inset ring-slate-900",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  status?: OrderStatus;
}

const Badge: React.FC<BadgeProps> = ({
  className,
  variant,
  status,
  children,
  ...props
}) => {
  const badgeVariant = status ?? variant;

  return (
    <div
      className={cn(badgeVariants({ variant: badgeVariant }), className)}
      {...props}
    >
      {children}
    </div>
  );
};

export { Badge, badgeVariants };
